import { render, staticRenderFns } from "./parkList.vue?vue&type=template&id=18959038&"
import script from "./parkList.vue?vue&type=script&lang=js&"
export * from "./parkList.vue?vue&type=script&lang=js&"
import style0 from "./parkList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports